import { render, staticRenderFns } from "./AgendaGeneralSettings.vue?vue&type=template&id=17b562b3&scoped=true&"
import script from "./AgendaGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./AgendaGeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./AgendaGeneralSettings.vue?vue&type=style&index=0&id=17b562b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b562b3",
  null
  
)

export default component.exports